'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PublicationTimestamp = function PublicationTimestamp(_ref) {
    var value = _ref.text.value,
        theme = _ref.theme;

    var timestamps = value.split('\n');

    return _react2.default.createElement(
        'div',
        { className: theme.timestamp, 'x-ms-format-detection': 'none' },
        _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement(
                'span',
                { className: theme.visuallyhidden },
                'Publisert:'
            ),
            _react2.default.createElement(
                'time',
                null,
                timestamps[0]
            )
        ),
        timestamps[1] && _react2.default.createElement(
            'span',
            null,
            timestamps[1]
        )
    );
};

PublicationTimestamp.propTypes = {
    text: _propTypes2.default.shape({
        value: _propTypes2.default.string.isRequired
    }).isRequired,
    theme: _propTypes2.default.shape({
        timestamp: _propTypes2.default.string
    }).isRequired
};

PublicationTimestamp.defaultProps = {
    theme: {}
};

exports.default = PublicationTimestamp;
//# sourceMappingURL=PublicationTimestamp.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@vg/publication-timestamp/lib/cjs/PublicationTimestamp.js
 ** module id = 734
 ** module chunks = 1
 **/